import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="show-all"
export default class extends Controller {
  static targets = ["button", "loader"]

  connect() {
    console.log("Show all controller connected")
  }

  // Show loading indicator when button is clicked
  showLoader(event) {
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.remove('d-none')
    }
    if (this.hasButtonTarget) {
      // Hide the button immediately for visual feedback
      this.buttonTarget.classList.add('d-none')
      // Defer disabling to allow the form submission to proceed
      // Disabling during the click event would cancel form submission
      requestAnimationFrame(() => {
        if (this.hasButtonTarget) {
          this.buttonTarget.disabled = true
        }
      })
    }
  }

  // Hide loading indicator and re-enable button
  hideLoader() {
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.add('d-none')
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = false
    }
  }
}
